import fetchAPI from '../../../utils/fetchAPI';

import { TAsqClient, TAsqPayload } from 'types/TAsq';

type TParams = {
  itemId: string;
  xsrfToken: string;
  message: TAsqPayload['message'];
  offerAmount: TAsqPayload['offerAmount'];
  buyerName?: TAsqPayload['buyerName'];
  buyerPhoneNumber?: TAsqPayload['buyerPhoneNumber'];
  location?: TAsqPayload['location'];
  vehicleTradeInRequest?: TAsqPayload['vehicleTradeInRequest'];
  financingInfoRequest?: TAsqPayload['financingInfoRequest'];
  callbackRequest?: TAsqPayload['callbackRequest'];
  visitOrTestDriveRequest?: TAsqPayload['visitOrTestDriveRequest'];
  isPostAsqV2Disabled?: boolean;
};

export default async function sendAsq({
  itemId,
  xsrfToken,
  message,
  offerAmount,
  buyerName,
  buyerPhoneNumber,
  location,
  vehicleTradeInRequest,
  financingInfoRequest,
  callbackRequest,
  visitOrTestDriveRequest,
  isPostAsqV2Disabled,
}: TParams): Promise<TAsqClient> {
  try {
    return await fetchAPI({
      url: '/v/api/asq',
      method: 'POST',
      xsrfToken,
      payload: {
        itemId,
        message,
        offerAmount,
        buyerName,
        buyerPhoneNumber,
        location,
        vehicleTradeInRequest,
        financingInfoRequest,
        visitOrTestDriveRequest,
        callbackRequest,
        isPostAsqV2Disabled,
      },
    });
  } catch {
    return {};
  }
}
